<template>
	<button
		class="flex items-center gap-2 rounded border border-won-green bg-white px-3 py-1.5"
		@click="clickHandler"
	>
		<UserGroupIcon
			class="size-[18px] text-won-green"
		/>

		<span class="font-[Roboto] text-base font-medium text-won-green">
			Share
		</span>
	</button>
</template>

<script setup>
import { toRefs } from 'vue';
import { UserGroupIcon } from '@heroicons/vue/24/outline';
import { useResumeShare } from '../../store/share-resume.store';

const emit = defineEmits(['click-handler']);
const props = defineProps({
	emitClickEvent: {
		type: Boolean,
		default: false
	}
});
const { emitClickEvent } = toRefs(props);

const resumeShareStore = useResumeShare();

const clickHandler = () => {
	if (emitClickEvent.value) {
		emit('click-handler');
	} else {
		resumeShareStore.setShowShareModal();
	}
};
</script>
